module.exports = __webpack_public_path__ + "media/images/redesign-images/cm/blake-poster-ca72731704e82d0044ad97a51b29b067.jpg";